export default "__VITE_ASSET__Bh9XVWvA__"